module.exports = __webpack_public_path__ + "img/members-right-qz2.17edc0fd.png";